// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.6.14-XM80lRoYRUdkHMpUfMaX/mode=imports,min/optimized/keen-slider.js'

const { config } = window.BAO.Carousel
const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins
const { debounce } = window.BAO.Utils

class InstagramCirclesSmall extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()
    if (!this.els?.slides?.element) return
    this.centerCarousel()
    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.onResize = this.onResize.bind(this)
    this.debouncedResize = debounce(event => {
      this.onResize(event)
    }, 500)
    this.listeners.add(window, 'resize', this.debouncedResize)
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'free',
        defaultAnimation: {
          duration: config.defaultAnimation.duration,
        },
        dragSpeed: config.dragSpeed,
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 6,
            },
          },
          '(min-width: 1700px)': {
            slides: {
              perView: 8,
            },
          },
        },
        slides: {
          perView: 'auto',
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }

  onResize (event) {
    this.centerCarousel()
  }

  centerCarousel () {
    if (!this.els?.slide?.exists) return
    this.els.slides.element.setAttribute(
      'data-centered',
      String(this.carouselWidth < document.body.offsetWidth),
    )
  }

  get carouselWidth () {
    return this.els.slide.elements.length * this.els.slide.element.offsetWidth
  }
}

if (!customElements.get('instagram-circles-small')) {
  customElements.define('instagram-circles-small', InstagramCirclesSmall)
}
